@if (!isMobile || (isMobile && !isAnagraficaVisibile())) {
  <div class="switch">
    @if (isAnagraficaVisibile()) {
      <span class="button" matRipple (click)="switchApp('ana')">
        <mat-icon>people_outline</mat-icon>
        Anagrafica
      </span>
    }
    <span class="button selected" matRipple>
      @if (!isMobile) {
        <mat-icon>work_outline</mat-icon>
      }
      Servizi
    </span>
    @if (this.utente && this.utente?.tipo_utente !== 6) {
      <span class="button" matRipple (click)="switchApp('soc')">
        @if (!isMobile) {
          <mat-icon>language</mat-icon>
        }
        Social
      </span>
    }
  </div>
}

@if (isMobile && isAnagraficaVisibile()) {
  <button class="button_primary" mat-raised-button [matMenuTriggerFor]="menu">
    <span class="button_container">
      <span>Servizi</span>
      <span class="arrow-down">&#x25BC;</span>
    </span>
  </button>
}
<mat-menu [overlapTrigger]="false" #menu="matMenu">
  @if (isAnagraficaVisibile()) {
    <a (click)="switchApp('ana')">
      <button mat-menu-item>
        <span class="button_container"><span>Anagrafica</span></span>
      </button>
    </a>
  }

  @if (this.utente && this.utente?.tipo_utente !== 6) {
    <a (click)="switchApp('soc')">
      <button mat-menu-item>
        <span class="button_container"><span>Social</span></span>
      </button>
    </a>
  }
</mat-menu>
